export const SHARE_TRAINER = 'SHARE_TRAINER';
export const SHARE_COURSE = 'SHARE_COURSE';
export const SHARE_INVITE = 'SHARE_INVITE';
export const SHARE_SUCCESS = 'SHARE_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/share/types.js